import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-loader',
    styleUrls: ['loader.component.scss'],
    template: `
        @if (isBusy) {
            <div class="loader-container">
                <div class="sk-rotating-plane"></div>
            </div>
        } @else {
            <ng-container *ngTemplateOutlet="detailRef"></ng-container>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent {
    @ContentChild(TemplateRef, { static: true }) detailRef;
    @Input() isBusy = true;
}
